"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMedicalAssistantApiPayloadSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
exports.createMedicalAssistantApiPayloadSchema = zod_1.z.object({
    firstname: zod_1.z.string().min(1),
    lastname: zod_1.z.string().min(1),
    email: zod_1.z.string().email(),
    phone: zod_1.z.string().nullable().optional(),
    contractType: enums_1.contractTypeSchema,
    weeklyHours: zod_1.z.number().int().min(1).max(168),
    hireDate: zod_1.z.string().date(),
    officeIds: zod_1.z.array(zod_1.z.string().uuid()),
    hasSupplementaryHealthInsurance: zod_1.z.boolean().optional(),
    hasTransportAllowance: zod_1.z.boolean().optional(),
});
